/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ProfileIcon/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function ProfileIcon({
  children,
  viewPath = "/DesignSystem/Svgs/ProfileIcon",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "none",
  stroke = "#474747"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="ProfileIcon.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-2bgpRX': alignSelf,'--mt-2-2bgpRX': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2bgpRX': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2bgpRX': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2bgpRX': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2bgpRX': opacity,'--w-10-2bgpRX': typeof width === 'number' ? `${width}px` : width,'--h-11-2bgpRX': typeof height === 'number' ? `${height}px` : height,'--a-7-2bgpRX': isAnimated ? animation : "none",'--sd-8-2bgpRX': isAnimated ? strokeDashoffset : 0,'--sd-9-2bgpRX': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<circle
  data-testid="ProfileIcon.SvgCircle"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 cx={16}
 cy={13}
 r={10.1}
 style={{'--f-12-2bgpRX': fill,'--s-13-2bgpRX': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="ProfileIcon.SvgPath"
  data-view-path={viewPath}
 strokeWidth={3}
 strokeMiterlimit={10}
 d="M3.6 29.2c6.9-6.9 17.9-6.9 24.8 0"
 style={{'--f-12-2bgpRX': fill,'--s-13-2bgpRX': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}